// eslint-disable-next-line no-unused-vars
import { modulePage } from '../../index';
var termsLoader = function () {
    return import(/* webpackMode: "lazy", webpackChunkName: "terms" */ './termsContent');
};
var termsPages = function (privacyContacts) {
    return ({
        content: [
            {
                pageLocation: 'policies/terms',
                image: { imageName: 'banners/terms', title: 'Terms of Use' },
                pageTitle: 'Terms',
                content: function (pco) { return modulePage(pco, 'terms', 'terms', termsLoader); },
                name: 'terms'
            },
            {
                pageLocation: 'policies/privacy',
                image: { imageName: 'banners/privacy', title: 'Privacy Policy' },
                pageTitle: 'Privacy',
                content: function (pco) { return modulePage(pco, 'privacy', 'terms', termsLoader, privacyContacts); },
                name: 'privacy'
            }
        ],
        subMenu: [
            { label: 'policies' },
            { label: 'website terms', shortLabel: 'terms', link: '/policies/terms' },
            { label: 'privacy policy', shortLabel: 'privacy', link: '/policies/privacy' }
        ]
    });
};
export { termsPages };
//# sourceMappingURL=termsPages.js.map